import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {DentnetCommunicatorService} from '../services/dentnet-communicator.service';
import {SurgeryDataModelService} from '../data-models/surgery-data-model.service';
import {RequestTimeService} from '../services/request-time.service';
import {AppConstants} from '../../constants/app-constants';

@Injectable()
export class DentnetItemResolverService implements Resolve<any> {

  constructor(private communicator: DentnetCommunicatorService, private dataModel: SurgeryDataModelService, public requestTimeService: RequestTimeService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const uname = route.params['uname'];
    if (this.requestTimeService.calcDiff(this.dataModel.maxSecondsBetween, this.dataModel.lastRequest)
    ) {
      this.dataModel.lastRequest = Date.now();
      return this.communicator.view(AppConstants.SURGERIES, this.dataModel, uname);
    }
    return true;
  }

}
